// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__QP3FQ","checkboxCol":"Table_checkboxCol__1UxCn","emailCol":"Table_emailCol__2H0Yd","actionCol":"Table_actionCol__1D8s7"};